import { render, staticRenderFns } from "./GoodsSeriesList.vue?vue&type=template&id=03f535c4&scoped=true&"
import script from "./GoodsSeriesList.vue?vue&type=script&lang=js&"
export * from "./GoodsSeriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f535c4",
  null
  
)

export default component.exports